import React from 'react'
import { NotFound } from 'lib/shared'

export const NoMatch = () => {
  return (
    <NotFound />
  )
}
